import React from 'react';

/**
 * 我的信息图标
 */
export const MyProfileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <clipPath id="my_profile_clip">
        <rect x="0" y="0" width="24" height="24" rx="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#my_profile_clip)">
      <path
        d="M20.9997734375,8.0002499L20.9997734375,7.0004997L17.9997734375,9.000749599999999L14.9997734375,7.0004997L14.9997734375,8.0002499L17.9997734375,10.000499699999999L20.9997734375,8.0002499ZM21.9995234375,3.00000017881393L1.9992735375000001,3.00000017881393C0.8943937975,2.9995855093,-0.00139147142,3.8953709,-0.00097641852335,5.000250100000001L-0.00097641852335,19.0005C-0.00139119499,20.105379,0.8943946375,21.001163,1.9992737374999998,21.00075L21.9995234375,21.00075C23.1023714375,21.000347,23.9946724375,20.103336,23.9892734375,19.0005L23.9990234375,5.000250100000001C23.9994394375,3.89537054,23.1036534375,2.99958497286,21.9987734375,3.00000017881393L21.9995234375,3.00000017881393ZM8.0000238375,6C9.6568775375,6,11.0000234375,7.3431458,11.0000234375,9C11.0000234375,10.6568542,9.6568775375,12,8.0000238375,12C6.3431692375,12,5.0000238375,10.6568542,5.0000238375,9C5.0000238375,7.3431458,6.3431692375,6,8.0000238375,6ZM14.0000224375,18L2.0000233375,18L2.0000233375,17.00025C2.0000233375,15,5.9997739375,13.9005,8.0000238375,13.9005C10.0002734375,13.9005,14.0000224375,15.00075,14.0000224375,17.00025L14.0000224375,18ZM21.9995234375,12L13.9992734375,12L13.9992734375,6L21.9995234375,6L21.9995234375,12Z"
        fill="currentColor"
        fillOpacity="0.85"
      />
    </g>
  </svg>
);
